<template>
  <div class="my-4">
    <label class="form-label speedee-bold float-left">Select Folder</label>
    <select class="form-select" v-model="selectedFolder">
      <option v-for="folder in folders" :key="folder.id" :value="folder.id">
        {{ folder.name }}
      </option>
    </select>
  </div>
  <div
    class="dz-message upload-media dropzone-container"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
  >
    <span class="media-file-input">
      <input
        type="file"
        multiple
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        accept=".pdf,.jpg,.jpeg,.png"
      />
    </span>
    <label for="fileInput" class="file-label">
      <i class="fa fa-plus-circle iconSize"></i>
      <div v-if="isDragging">Release to drop files here.</div>
      <div v-else>
        <u>Select from Media Library</u> or Drag your image here. <br />
        <span class="title">(Image Size 5 Mb)</span>
      </div>
    </label>

    <div class="preview-container mt-4" v-if="files.length">
      <div v-for="file in files" :key="file.name" class="preview-card">
        <div>
          <img class="preview-img" :src="generateURL(file)" />
          <p>
            {{ file.name }}
          </p>
        </div>
        <div>
          <button
            class="ml-2"
            type="button"
            @click="remove(files.indexOf(file))"
            title="Remove file"
          >
            <b>×</b>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="fileLimitExceeded" class="error-message text-red text-center">
    You can only select a maximum of 5 files.
  </div>
  <div class="button-media">
    <button @click="uploadFiles()" class="uploadBtn">Upload</button>
  </div>
</template>

<script>
import { postRequest } from "@/services/RequestService";
export default {
  props: {
    folders: {
      type: Array, // Adjust the prop type based on your data structure
      required: true,
    },
  },

  data() {
    return {
      isDragging: false,
      files: [],
      selectedFolder: 1,
      fileLimitExceeded: false,
    };
  },

  mounted() {
    console.log(this.folders);
  },

  methods: {
    onChange() {
      if (this.$refs.file.files.length > 5) {
        // Display an error message or take appropriate action
        this.fileLimitExceeded = true;
        // Clear the input field to remove excess files
        this.$refs.file.value = "";
      } else {
        // Update the this.files array with selected files
        this.files = [...this.$refs.file.files];
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(i) {
      this.files.splice(i, 1);
    },
    generateURL(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },

    async uploadFiles() {
      const files = this.files;
      const formData = new FormData();

      files.forEach((file) => {
        formData.append("folder_id", this.selectedFolder);
        formData.append("image[]", file);
      });

      let response = await postRequest("/galleries", formData, {
        accept: "multipart/form-data",
      });

      if (response.data.success) {
        this.$swal({
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
          confirmButtonText: "Close",
        }).then(function () {
          window.location.reload();
        });
      }
    },
  },
};
</script>


<style>
.dropzone-container {
  padding: 4rem;
  background: rgb(230, 228, 228);
  border: 1px solid #e2e8f0;
  text-align: center;
  border: 2px dashed black !important;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.button-media {
  display: flex !important;
  justify-content: center;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.iconSize {
  font-size: 2em !important;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}
</style>